import React, { Component } from 'react'
import { connect } from 'react-redux'
import { setCustomerEventsSearchTerm, setCustomerEventsFilter } from 'actions'
import { getCustomerRequestByWorkspaceSlug, getMatchingEvents } from 'selectors'
import CustomersProfileEvents from '../components/Customers/CustomersProfileEvents'

class CustomersProfileAppEvents extends Component {
  render () {
    return React.createElement(CustomersProfileEvents, this.props)
  }
}

function mapStateToProps (state, ownProps) {
  const { workspaceSlug } = ownProps.params

  const { isRequesting, didRequestFail } = getCustomerRequestByWorkspaceSlug(state, workspaceSlug)
  const events = getMatchingEvents(state, workspaceSlug)

  return {
    events,
    workspaceSlug,
    didRequestFail,
    isRequesting
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  return {
    onSearch: str => dispatch(setCustomerEventsSearchTerm(str)),
    onFilterChange: str => dispatch(setCustomerEventsFilter(str))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomersProfileAppEvents)



// WEBPACK FOOTER //
// ./containers/CustomersProfileAppEvents.js